import * as SystemParametersModel from "@/model/adm/SystemParameters";
import * as MessageDataConversionModel from "@/model/adm/MessageDataConversion";
import * as UserSettingModel from '@/model/adm/UserSetting';
import * as RoleModel from '@/model/adm/Role';
import * as DataFieldModel from '@/model/adm/DataField';
import * as ChartModel from '@/model/adm/Chart';

//master
import * as LocationModel from "@/model/master/Location";
import * as EquipmentModel from "@/model/master/Equipment";
import * as MaterialModel from "@/model/master/Material";
import * as EnergyModel from "@/model/master/Energy";
import * as TeamShiftModel from '@/model/master/teamShift/TeamShift'

import * as ProcessOptionModel from "@/model/master/processConf/ProcessOption";
import * as ProcessMaterialModel from "@/model/master/processConf/ProcessMaterial";
import * as ProcessEnergyModel from "@/model/master/processConf/ProcessEnergy";

//prd plan
import * as DowntimePlanModel from "@/model/prd/productionPlan/DowntimePlan";
import * as MonthPlanModel from "@/model/prd/productionPlan/MonthPlan";
import * as MatRequireMonthPlanModel from "@/model/prd/productionPlan/MatRequireMonthPlan";
import * as ShiftPlanModel from "@/model/prd/productionPlan/ShiftPlan";

//inventory
import * as RawMaterialModel from "@/model/prd/inventoryMgt/RawMaterial";
import * as AdjustModel from "@/model/prd/inventoryMgt/Adjust";
import * as OutInModel from "@/model/prd/inventoryMgt/OutIn";
import * as FormulaPlanModel from "@/model/prd/inventoryMgt/FormulaPlan"
import * as FormulaPlanDetailsModel from "@/model/prd/inventoryMgt/FormulaPlanDetails"

//quality
import * as QualityItemModel from "@/model/prd/qualityMgt/qualityItemConfig/QualityItem";
import * as QualityItemDetailsModel from "@/model/prd/qualityMgt/qualityItemConfig/QualityItemDetails";
import * as SelfTestPelletizingModel from "@/model/prd/qualityMgt/selfTest/SelfTestPelletizing";
import * as SelfTestPelletizingGriModel from "@/model/prd/qualityMgt/selfTest/SelfTestPelletizingGri";
import * as SelfTestPelletizingPelModel from "@/model/prd/qualityMgt/selfTest/SelfTestPelletizingPel";
import * as SelfTestPelletizingCalModel from "@/model/prd/qualityMgt/selfTest/SelfTestPelletizingCal";
import * as QualityPlanModel from "@/model/prd/qualityMgt/pelletizing/QualityPlan";
import * as QualitySamplePlanModel from "@/model/prd/qualityMgt/pelletizing/QualitySamplePlan";
import * as QualityDataModel from "@/model/prd/qualityMgt/pelletizing/QualityData";
import * as QualityResultModel from "@/model/prd/qualityMgt/pelletizing/QualityResult";
import * as QualitySpecificationModel from "@/model/prd/qualityMgt/QualitySpecification";
import * as SlagMeltingPointModel from "@/model/prd/qualityMgt/pelletizing/SlagMeltingPoint";
import * as Log from "@/model/adm/Log";

//prd result
import * as PelletizingEnergyCostModel from "@/model/prd/productionExecution/pelletizing/PelletizingEnergyCost";
import * as PelletizingEquipParaModel from "@/model/prd/productionExecution/pelletizing/PelletizingEquipPara";
import * as PelletizingMaterialCostModel from "@/model/prd/productionExecution/pelletizing/PelletizingMaterialCost";
import * as PelletizingProductInfoModel from "@/model/prd/productionExecution/pelletizing/PelletizingProductInfo";
import * as PelletizingProductionResultModel
    from "@/model/prd/productionExecution/pelletizing/PelletizingProductionResult";
import * as PelletizingProductQualityModel from "@/model/prd/productionExecution/pelletizing/PelletizingProductQuality";
import * as PelletizingProductionQualityModel
    from "@/model/prd/productionExecution/pelletizing/PelletizingProductionQuality";
import * as PelletizingProductionQualityItemModel
    from "@/model/prd/productionExecution/pelletizing/PelletizingProductionQualityItem";

import * as SmeltingEnergyCostModel from "@/model/prd/productionExecution/smelting/SmeltingEnergyCost";
import * as SmeltingEquipParaModel from "@/model/prd/productionExecution/smelting/SmeltingEquipPara";
import * as SmeltingMaterialCostModel from "@/model/prd/productionExecution/smelting/SmeltingMaterialCost";
import * as SmeltingProductInfoModel from "@/model/prd/productionExecution/smelting/SmeltingProductInfo";
import * as SmeltingProductionResultModel from "@/model/prd/productionExecution/smelting/SmeltingProductionResult";
import * as SmeltingProductQualityModel from "@/model/prd/productionExecution/smelting/SmeltingProductQuality";
import * as SmeltingProductionQualityModel from "@/model/prd/productionExecution/smelting/SmeltingProductionQuality";
import * as SmeltingProductionQualityItemModel
    from "@/model/prd/productionExecution/smelting/SmeltingProductionQualityItem";


//Report
import * as DayEnergyCostModel from "@/model/prd/productionReport/dayReport/DayEnergyCost";
import * as DayEquipParaModel from "@/model/prd/productionReport/dayReport/DayEquipPara";
import * as DayMaterialCostModel from "@/model/prd/productionReport/dayReport/DayMaterialCost";
import * as DayPelletizingProductInfoModel from "@/model/prd/productionReport/dayReport/DayPelletizingProductInfo";
import * as DayPelletizingProductQualityModel
    from "@/model/prd/productionReport/dayReport/DayPelletizingProductQuality";
import * as DaySmeltingProductInfoModel from "@/model/prd/productionReport/dayReport/DaySmeltingProductInfo";
import * as DaySmeltingProductQualityModel from "@/model/prd/productionReport/dayReport/DaySmeltingProductQuality";
import * as MonthEnergyCostModel from "@/model/prd/productionReport/monthReport/MonthEnergyCost";
import * as MonthEquipParaModel from "@/model/prd/productionReport/monthReport/MonthEquipPara";
import * as MonthMaterialCostModel from "@/model/prd/productionReport/monthReport/MonthMaterialCost";
import * as MonthPelletizingProductInfoModel
    from "@/model/prd/productionReport/monthReport/MonthPelletizingProductInfo";
import * as MonthPelletizingProductQualityModel
    from "@/model/prd/productionReport/monthReport/MonthPelletizingProductQuality";
import * as MonthSmeltingProductInfoModel from "@/model/prd/productionReport/monthReport/MonthSmeltingProductInfo";
import * as MonthSmeltingProductQualityModel
    from "@/model/prd/productionReport/monthReport/MonthSmeltingProductQuality";
import * as MonthPelletizingProductionQualityModel
    from "@/model/prd/productionReport/monthReport/MonthPelletizingProductionQuality";
import * as MonthPelletizingProductionQualityItemModel
    from "@/model/prd/productionReport/monthReport/MonthPelletizingProductionQualityItem";
import * as MonthSmeltingProductionQualityModel
    from "@/model/prd/productionReport/monthReport/MonthSmeltingProductionQuality";
import * as MonthSmeltingProductionQualityItemModel
    from "@/model/prd/productionReport/monthReport/MonthSmeltingProductionQualityItem";
import * as DayPelletizingProductionQualityModel
    from "@/model/prd/productionReport/dayReport/DayPelletizingProductionQuality";
import * as DayPelletizingProductionQualityItemModel
    from "@/model/prd/productionReport/dayReport/DayPelletizingProductionQualityItem";
import * as DaySmeltingProductionQualityModel
    from "@/model/prd/productionReport/dayReport/DaySmeltingProductionQuality";
import * as DaySmeltingProductionQualityItemModel
    from "@/model/prd/productionReport/dayReport/DaySmeltingProductionQualityItem";

//prd record
import * as FurnaceTemperatureModel from "@/model/prd/dailyReportMgt/FurnaceTemperature";
import * as CeramicFilterParaModel from "@/model/prd/productionExecution/pelletizing/CeramicFilterPara";
import * as SmeltingPreheatingKilnParaModel from "@/model/prd/productionExecution/smelting/SmeltingPreheatingKilnPara";
import * as SmeltingFurnaceMeasureModel from "@/model/prd/productionExecution/smelting/SmeltingFurnaceMeasure";
import * as CoolingWaterParaModel from "@/model/prd/productionExecution/smelting/CoolingWaterPara";
import * as ElectrodePasteParaModel from "@/model/prd/productionExecution/smelting/ElectrodePastePara";
import * as ThickenerPumpParaModel from "@/model/prd/productionExecution/smelting/ThickenerPumpPara";
import * as SmeltingPreheatingKilnStopModel from "@/model/prd/productionExecution/smelting/SmeltingPreheatingKilnStop";
import * as PressureDropWeightChangeModel from "@/model/prd/productionExecution/smelting/PressureDropWeightChange";
import * as ReleasedElectrodeParaModel from "@/model/prd/productionExecution/smelting/ReleasedElectrodePara";
import * as ElectrodeDischargePlanModel from "@/model/prd/productionExecution/smelting/ElectrodeDischargePlan";
import * as GasCabinetParaModel from "@/model/prd/productionExecution/smelting/GasCabinetPara";
import * as GasFlowParaModel from "@/model/prd/productionExecution/smelting/GasFlowPara";
import * as SubstationOperationParaModel from "@/model/prd/productionExecution/smelting/SubstationOperationPara";
import * as FurnacePowerFailureModel from "@/model/prd/productionExecution/smelting/FurnacePowerFailure";
import * as SlagIronParaModel from "@/model/prd/productionExecution/smelting/SlagIronPara";
import * as ElectrodeResistanceModel from "@/model/prd/productionExecution/smelting/ElectrodeResistance";
import * as DrillDepthModel from "@/model/prd/productionExecution/smelting/DrillDepth";
import * as PelletFeedingModel from "@/model/prd/productionExecution/smelting/PelletFeeding";
import * as SmeltingMaterialPercentRecordModel
    from "@/model/prd/productionExecution/smelting/SmeltingMaterialPercentRecord";

import * as ShiftHandOverModel from "@/model/prd/shiftHandOver/ShiftHandOver";
import * as ProductionInform from "@/model/prd/productionInform/ProductionInform";

import * as ReportTemplate from "@/model/report/ReportTemplate";

import * as QuartzSchedule from "@/model/quartz/QuartzSchedule";

//em
import * as emModel from "@/model/em/index-em-model";
import * as emAssistantModel from "@/model/emAssistant/index-emAssistant-model"

//sithMes
import * as sithMesModel from "@/model/sithMes/index-sithMes-model";
import * as sithMesIIModel from "@/model/sithMesII/index-sithMesII-model";

import * as mintalMesModel from "@/model/mintalMes/index-mintalMes-model"

//party-building
import * as partyBuilding from "@/model/party-building/moduleIndex-model-party-building"



export default {
    "userSetting": UserSettingModel,
    "role": RoleModel,
    "systemParameters": SystemParametersModel,
    "messageDataConversion": MessageDataConversionModel,
    "dataField": DataFieldModel,
    "chart": ChartModel,

    //master
    "location": LocationModel,
    "equipment": EquipmentModel,
    "energy": EnergyModel,
    "material": MaterialModel,
    "teamShift": TeamShiftModel,
    "processOption": ProcessOptionModel,
    "processMaterial": ProcessMaterialModel,
    "processEnergy": ProcessEnergyModel,

    //prd plan
    "downtimePlan": DowntimePlanModel,
    "monthPlan": MonthPlanModel,
    "matRequireMonthPlan": MatRequireMonthPlanModel,
    "shiftPlan": ShiftPlanModel,

    //inventory
    "rawMaterial": RawMaterialModel,
    "adjust": AdjustModel,
    "outIn": OutInModel,
    "formulaPlan": FormulaPlanModel,
    "formulaPlanDetails": FormulaPlanDetailsModel,

    //quality
    "qualityItem": QualityItemModel,
    "qualityItemDetails": QualityItemDetailsModel,
    "selfTestPelletizing": SelfTestPelletizingModel,
    "selfTestPelletizingGri": SelfTestPelletizingGriModel,
    "selfTestPelletizingPel": SelfTestPelletizingPelModel,
    "selfTestPelletizingCal": SelfTestPelletizingCalModel,
    "qualityPlan": QualityPlanModel,
    "qualitySamplePlan": QualitySamplePlanModel,
    "qualityData": QualityDataModel,
    "qualityResult": QualityResultModel,
    "qualitySpecification": QualitySpecificationModel,
    "slagMeltingPoint": SlagMeltingPointModel,

    //prd result
    "pelletizingEnergyCost": PelletizingEnergyCostModel,
    "pelletizingEquipPara": PelletizingEquipParaModel,
    "pelletizingMaterialCost": PelletizingMaterialCostModel,
    "pelletizingProductInfo": PelletizingProductInfoModel,
    "pelletizingProductionResult": PelletizingProductionResultModel,
    "pelletizingProductQuality": PelletizingProductQualityModel,
    "pelletizingProductionQuality": PelletizingProductionQualityModel,
    "pelletizingProductionQualityItem": PelletizingProductionQualityItemModel,

    "smeltingEnergyCost": SmeltingEnergyCostModel,
    "smeltingEquipPara": SmeltingEquipParaModel,
    "smeltingMaterialCost": SmeltingMaterialCostModel,
    "smeltingProductInfo": SmeltingProductInfoModel,
    "smeltingProductionResult": SmeltingProductionResultModel,
    "smeltingProductQuality": SmeltingProductQualityModel,
    "smeltingMaterialPercentRecord": SmeltingMaterialPercentRecordModel,
    "smeltingProductionQuality": SmeltingProductionQualityModel,
    "smeltingProductionQualityItem": SmeltingProductionQualityItemModel,

    //prd report
    "dayEnergyCost": DayEnergyCostModel,
    "dayEquipPara": DayEquipParaModel,
    "dayMaterialCost": DayMaterialCostModel,
    "dayPelletizingProductInfo": DayPelletizingProductInfoModel,
    "dayPelletizingProductQuality": DayPelletizingProductQualityModel,
    "daySmeltingProductInfo": DaySmeltingProductInfoModel,
    "daySmeltingProductQuality": DaySmeltingProductQualityModel,
    "monthEnergyCost": MonthEnergyCostModel,
    "monthEquipPara": MonthEquipParaModel,
    "monthMaterialCost": MonthMaterialCostModel,
    "monthPelletizingProductInfo": MonthPelletizingProductInfoModel,
    "monthPelletizingProductQuality": MonthPelletizingProductQualityModel,
    "monthSmeltingProductInfo": MonthSmeltingProductInfoModel,
    "monthSmeltingProductQuality": MonthSmeltingProductQualityModel,
    "monthPelletizingProductionQuality": MonthPelletizingProductionQualityModel,
    "monthPelletizingProductionQualityItem": MonthPelletizingProductionQualityItemModel,
    "monthSmeltingProductionQuality": MonthSmeltingProductionQualityModel,
    "monthSmeltingProductionQualityItem": MonthSmeltingProductionQualityItemModel,
    "dayPelletizingProductionQuality": DayPelletizingProductionQualityModel,
    "dayPelletizingProductionQualityItem": DayPelletizingProductionQualityItemModel,
    "daySmeltingProductionQuality": DaySmeltingProductionQualityModel,
    "daySmeltingProductionQualityItem": DaySmeltingProductionQualityItemModel,


    //prd record
    "furnaceTemperature": FurnaceTemperatureModel,
    "ceramicFilterPara": CeramicFilterParaModel,
    "smeltingPreheatingKilnPara": SmeltingPreheatingKilnParaModel,
    "smeltingFurnaceMeasure": SmeltingFurnaceMeasureModel,
    "coolingWaterPara": CoolingWaterParaModel,
    "electrodePastePara": ElectrodePasteParaModel,
    "thickenerPumpPara": ThickenerPumpParaModel,
    "smeltingPreheatingKilnStop": SmeltingPreheatingKilnStopModel,
    "pressureDropWeightChange": PressureDropWeightChangeModel,
    "releasedElectrodePara": ReleasedElectrodeParaModel,
    "electrodeDischargePlan": ElectrodeDischargePlanModel,
    "gasCabinetPara": GasCabinetParaModel,
    "gasFlowPara": GasFlowParaModel,
    "substationOperationPara": SubstationOperationParaModel,
    "furnacePowerFailure": FurnacePowerFailureModel,
    "slagIronPara": SlagIronParaModel,
    "electrodeResistance": ElectrodeResistanceModel,
    "drillDepth": DrillDepthModel,
    "pelletFeeding": PelletFeedingModel,
    "shiftHandOver": ShiftHandOverModel,
    "productionInform": ProductionInform,
    //report
    "reportTemplate": ReportTemplate,
    "quartzSchedule": QuartzSchedule,
    "log": Log,

    //em
    ...emModel,
    ...emAssistantModel,

    //em
    ...sithMesModel,
    ...sithMesIIModel,

    //mintal
    ...mintalMesModel,

    //party building
    ...partyBuilding
}
